import { memo, ReactNode, VFC, useState, useEffect } from "react";
import {
  Grid,GridItem,Center,Text,Box,
} from "@chakra-ui/react";
import { Navigation } from "../../molecules/Navigation";
import { Header } from "../../molecules/Header";

type Props = {
  children: ReactNode;
};

export const HeaderLayout: VFC<Props> = memo(props => {
  const { children } = props;
  const [ toYear, setToYear ] = useState('');
  
  // フッタ用今年の取得
  useEffect(() => {
    const toYearTmp = (new Date(Date.now() + ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000))).getFullYear();
    if( toYear === '' && toYearTmp !== 2023 ){
      setToYear('-'+toYearTmp);
    }
  }, []);
  
  return (
    <Grid
      templateAreas={`"header header"
                      "navi main"
                      "footer footer"`}
      gridTemplateRows={'48px 1fr 30px'}
      gridTemplateColumns={{ base: "0px 1fr", md: '170px 1fr' }}
      gap='1'
      h='200px'
      color='blackAlpha.700'
    >
      <GridItem bg='white' area={'header'}>
        <Header />
      </GridItem>
      <GridItem area={'navi'}>
        <Box display={{ base: "none", md: "block" }}> {/* for mobile */}
          <Navigation />
        </Box>
      </GridItem>
      <GridItem area={'main'}>
        {children}
      </GridItem>
      <GridItem bg='white.100' area={'footer'}>
        <Center>
          <Text>{`© NEC Corporation 2023${toYear}`}</Text>
        </Center>
      </GridItem>
    </Grid>
  );
});
